import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { OwnPurchasesPage } from '@/features/subcontracts/purchases-page';

const searchSchema = z.object({
  purchase: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/subcontracts/purchases')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const { purchase } = Route.useSearch();
  return <OwnPurchasesPage projectId={projectId} purchaseId={purchase} />;
}
